/* Product quantity captions in Azerbaijani on phones and tablets. */
(function () {
  'use strict';
  var touch = window.matchMedia('(max-width: 989px), (max-width: 1366px) and (pointer: coarse)');
  var observer;
  var queued = false;

  function translate() {
    queued = false;
    if (!touch.matches) return;
    document.querySelectorAll('product-info .quantity__label').forEach(function (label) {
      var rules = label.querySelector('.quantity__rules-cart');
      var counter = rules && rules.querySelector('.quantity-cart');
      var countText = counter && counter.textContent.trim();
      var count = countText && /^\d+$/.test(countText) ? Number(countText) : 0;
      var validCount = !!counter && /^\d+$/.test(countText) && Number.isSafeInteger(count);
      var caption = counter && counter.closest('span:not(.quantity-cart)');
      var first = Array.from(label.children).find(function (child) {
        return child.tagName === 'SPAN' && child !== rules;
      });
      if (first && first.textContent !== 'Miqdar') first.textContent = 'Miqdar';
      if (caption && caption !== rules && validCount) {
        var text = '(səbətdə ' + countText + ')';
        if (caption.textContent.trim() !== text) {
          caption.replaceChildren(document.createTextNode('(səbətdə '), counter, document.createTextNode(')'));
        }
      }
      var aria = count > 0 && rules && !rules.classList.contains('hidden')
        ? 'Miqdar, səbətdə ' + countText : 'Miqdar';
      (label.getAttribute('aria-labelledby') || '').split(/\s+/).forEach(function (id) {
        var hidden = id && document.getElementById(id);
        if (hidden && hidden.classList.contains('visually-hidden') && hidden.closest('product-info') === label.closest('product-info') && hidden.textContent !== aria) {
          hidden.textContent = aria;
        }
      });
    });
  }

  function schedule() {
    if (!touch.matches || queued) return;
    queued = true;
    queueMicrotask(translate);
  }

  function activate() {
    if (!touch.matches) {
      if (observer) observer.disconnect();
      return;
    }
    if (!document.body) return;
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'aria-labelledby']
    });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activate, { once: true });
  else activate();
  touch.addEventListener('change', activate);
  document.addEventListener('product-info:loaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
})();
